import "./assets/goalsAndCompliance.css";
import { useRef } from "react";
import { useEmployeesOrganizationQuery } from "./hooks/useEmployeesOrganizationQuery.js";
import { useTrainedEmployeesQuery } from "./hooks/useTrainedEmployessQuery.js";
import { useCountTasksGroupByStatusQuery } from "./hooks/useCountTasksGroupByStatusQuery";
import moment from "moment/moment";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import BarchartTypeTasks from "./components/BarchartTypeTasks";
import Button from "../../common/components/Button.jsx";
import Table from "../../common/components/Table.jsx";
import { useTasksGroupByQuarterQuery } from "./hooks/useTasksGroupByQuarterQuery.js";

const START_YEAR = moment().startOf("year").format("YYYY-MM-DD");
const END_YEAR = moment().endOf("year").format("YYYY-MM-DD");

const columns = [
  { header: "Año", accessor: "year" },
  { header: "Trimestre", accessor: "quarter" },
  { header: "Total capacitados", accessor: "totalTrained" },
  { header: "Total organización", accessor: "totalOrganization" },
];

function GoalsAndCompliance() {
  const dashboardRef = useRef();
  const buttonExportRef = useRef();

  const { tasks: completedTasks, loading } = useTasksGroupByQuarterQuery({
    status: "completada",
    type: "training",
    startDate: START_YEAR,
    endDate: END_YEAR,
  });
  const { employeesOrganization } = useEmployeesOrganizationQuery({
    startDate: START_YEAR,
    endDate: END_YEAR,
  });
  const { trainedEmployees } = useTrainedEmployeesQuery({
    startDate: START_YEAR,
    endDate: END_YEAR,
  });
  const { totalTasks } = useCountTasksGroupByStatusQuery({
    startDate: START_YEAR,
    endDate: END_YEAR,
  });

  const exportToPDF = () => {
    // Ocultar el boton de exportar mientras se genera el PDF
    buttonExportRef.current.disabled = true;
    buttonExportRef.current.style.opacity = 0;

    const input = dashboardRef.current;
    html2canvas(input, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 210;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
      pdf.save("metas-cumplimiento.pdf");
    });

    // Mostrar el boton de exportar una vez que se haya generado el PDF
    setTimeout(() => {
      buttonExportRef.current.disabled = false;
      buttonExportRef.current.style.opacity = 1;
    }, 1000);
  };

  return (
    <main className="container-fluid p-0 p-md-4" ref={dashboardRef}>
      <header className="d-flex justify-content-between align-items-center mb-4 px-3 py-2 border-bottom">
        <h1 className="h2 m-0 fw-bold">Metas y cumplimiento</h1>
        <div className="d-flex gap-2">
          <Button onClick={exportToPDF} reference={buttonExportRef}>
            Exportar a PDF
          </Button>
        </div>
      </header>

      <section className="d-block d-md-flex align-items-center gap-3 mx-auto">
        <div className="chart bar-chart mb-3">
          <BarchartTypeTasks data={totalTasks} />
        </div>

        <div className="stats-container">
          <article className="stat-box">
            <h3>Total colaboradores capacitados</h3>
            <span className="stat-number">{trainedEmployees ?? 0}</span>
          </article>
          <article className="stat-box">
            <h3>Promedio de colaboradores de la organización en el trismestre actual</h3>
            <span className="stat-number">{employeesOrganization}</span>
          </article>
        </div>
      </section>

      <section className="shadow w-100 d-flex flex-column mt-3">
        <Table
          columns={columns}
          data={completedTasks}
          loading={loading}
          showIndex={true}
        />

         {/* <Pagination
          onChangePage={onChangePage}
          page={currentPage}
          totalPages={totalPages}
        /> */}
      </section>
    </main>
  );
}

export default GoalsAndCompliance;
